module.exports = __webpack_public_path__ + "assets/snowflake-logo.png";